import React from 'react';
import autoBind from 'react-autobind';
import { Redirect, Route, Switch } from 'react-router-dom';
import CurrentUser from './CurrentUser';
import CurrentAccount from './CurrentAccount';
import BillingInformation from './BillingInformation';
import { PanelContainer } from '../../components/Panel';
import SidebarAccount from '../../components/Sidebar/SidebarAccount';
import SidebarPage from '../../components/Sidebar/components/SidebarPage';
import Groups from './Groups';
import Users from './Users';
import User from './User';
import Invitation from './Invitation';
import InvitationNew from './InvitationNew';
import Feedback from './Feedback';
import './style.scss';

import { appContainer, Subscribe } from '../../contexts/app';
import { UserAccountContext } from '../../contexts/userAccount';

class Account extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      fetching: false
    };
    autoBind(this);
  }

  handleRedirect(props) {
    // We need to ensure id's exist at each path endpoint
    // If not, this is either an invalid id or it has been deleted
    const { path, params } = props.match;
    let redirect = null;
    if (
      path === '/account/users/:userId' &&
      !props.app.state.get('users').has(params.userId)
    ) {
      redirect = `/account/users`;
    }
    if (
      path === '/account/invitations/:invitationId' &&
      !props.invitations.has(params.invitationId)
    ) {
      redirect = `/account/users`;
    }
    return redirect;
  }

  render() {
    const redirect = this.handleRedirect(this.props);
    if (redirect) {
      return <Redirect to={redirect} />;
    }
    const {
      currentUser,
      currentAccount,
      app,
      invitations,
      plans,
      match,
      userAccountContext,
      ownerName
    } = this.props;

    let { subscriptionStatus } = userAccountContext;

    const permissions = app.state.get('permissions');
    return (
      <div id="accountPage" className="authed-page">
        <SidebarAccount subscriptionStatus={subscriptionStatus} />
        <SidebarPage>
          <PanelContainer open={true} hideClose>
            <Switch>
              <Route
                exact
                path="/account"
                render={props => (
                  <div className="row">
                    <div className="col-sm-12 col-md-8 col-lg-6">
                      <CurrentUser
                        ownerName={ownerName}
                        currentUser={currentUser}
                        permissions={permissions}
                        subscriptionStatus={subscriptionStatus}
                      />
                    </div>
                  </div>
                )}
              />
              <Route
                exact
                path="/account/settings"
                render={() => (
                  <div className="row">
                    <div className="col-md-12 col-lg-6">
                      <CurrentAccount
                        ownerName={ownerName}
                        currentUser={currentUser}
                        currentAccount={currentAccount}
                        plans={plans}
                        permissions={permissions}
                        subscriptionStatus={subscriptionStatus}
                      />
                    </div>
                    <div className="col-md-12 col-lg-6">
                      <BillingInformation currentAccount={currentAccount} />
                    </div>
                  </div>
                )}
              />
              <Route
                exact
                path="/account/groups"
                render={() => (
                  <div>
                    <div className="row">
                      <div className="col-xs-12">
                        <Groups
                          currentAccount={currentAccount}
                          groups={app.state.get('groups')}
                          invitations={app.state.get('invitations')}
                          permissions={permissions}
                        />
                      </div>
                    </div>
                  </div>
                )}
              />
              <Route
                exact
                path="/account/users"
                render={() => (
                  <div>
                    <div className="row">
                      <div className="col-xs-12">
                        <Users app={app} currentUser={currentUser} />
                      </div>
                    </div>
                  </div>
                )}
              />
              <Route
                exact
                path="/account/users/:userId"
                render={props => (
                  <div>
                    <div className="row">
                      <div className="col-lg-9">
                        <User
                          currentUser={currentUser}
                          user={app.state.get('users').get(match.params.userId)}
                        />
                      </div>
                    </div>
                  </div>
                )}
              />
              <Route
                exact
                path="/account/invitations/:invitationId"
                render={props => (
                  <div>
                    <div className="row">
                      <div className="col-lg-9">
                        <Invitation
                          invitation={invitations.get(
                            match.params.invitationId
                          )}
                        />
                      </div>
                    </div>
                  </div>
                )}
              />
              <Route
                exact
                path="/account/invitations"
                render={props => (
                  <div>
                    <div className="row">
                      <div className="col-lg-9">
                        <InvitationNew {...props} />
                      </div>
                    </div>
                  </div>
                )}
              />
              <Route
                exact
                path="/account/feedback"
                render={props => (
                  <div>
                    <div className="row">
                      <div className="col-lg-7">
                        <Feedback {...props} />
                      </div>
                    </div>
                  </div>
                )}
              />
            </Switch>
          </PanelContainer>
        </SidebarPage>
      </div>
    );
  }
}

export default routerProps => {
  return (
    <UserAccountContext.Consumer>
      {userAccountContext => {
        return (
          <Subscribe
            to={[appContainer]}
            render={app => {
              return (
                <Account
                  {...routerProps}
                  app={app}
                  currentUser={app.state.get('currentUser')}
                  currentAccount={app.state.get('currentAccount')}
                  ownerName={app.state.get('ownerName')}
                  plans={app.state.get('plans')}
                  invitations={app.state.get('invitations')}
                  sidebarOpen={app.state.get('sidebarOpen')}
                  userAccountContext={userAccountContext}
                />
              );
            }}
          />
        );
      }}
    </UserAccountContext.Consumer>
  );
};



// WEBPACK FOOTER //
// ./src/pages/Account/index.jsx